import IMask from "imask";
import { Controller } from "stimulus";

export default class extends Controller {
  static values = { pattern: String };

  connect() {
    this.mask = IMask(this.element, { mask: this.patternValue });
  }

  disconnect() {
    this.mask?.destroy();
  }
}
